import {
  Animated,
  StyleSheet,
  ScrollView,
  View,
  Image,
  Text,
  useWindowDimensions,
} from "react-native";
import { useEffect, useRef } from "react";
import {
  BtnSidebarClosePng,
  GameRulesLight,
  GameRulesTitle,
  ModalTitle,
  RulesBackground,
} from "../../../assets";
import SvaraModal from "../Modals/SvaraModal";
import GameRuleSection from "./GameRulesModalComponents/GameRuleSection";
import { useDevice } from "../../../utils/hooks/useDevice";
import { useTranslation } from "react-i18next";
import RenderHTML from "react-native-render-html";
import { analyticsEvents } from "../../../services/firebase/analytics-events.service";
import ModalReusable from "./ModalReusable";

interface IProps {
  onClose: () => void;
}

function GameRulesModal({ onClose }: IProps) {
  const opacity = useRef(new Animated.Value(0)).current;
  const { isDesktop } = useDevice();
  const { t } = useTranslation();
  analyticsEvents.trackOpenRules();
  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 200,
      useNativeDriver: true,
    }).start();

    return () => {
      opacity.setValue(0);
    };
  }, []);

  const { width } = useWindowDimensions();
  const isMobile = width < 600;

  const raw = width * 0.6;
  const titleWidth = Math.max(350, raw);

  const handleClose = () => {
    Animated.timing(opacity, {
      toValue: 0,
      duration: 200,
      useNativeDriver: true,
    }).start(() => {
      onClose();
    });
  };
  // const stripHtml = (str: string) => str.replace(/<[^>]*>?/gm, "");
  const html = t("T_SITE_GAME_RULES_CONTENT");

  return (
    <>
      <ModalReusable
        visible
        onClose={onClose}
        // backgroundImage={RulesBackground}
        titleImage={ModalTitle}
        title={t("T_SITE_GAME_RULES_TITLE")}
        titleImageStyles={
          isMobile
            ? {
                width: titleWidth,
                minWidth: 360,
                height: 90,
                top: -55,
                // transform: [{ translateX: -titleWidth / 2 }],
              }
            : {
                width: titleWidth,
                minWidth: 380,
                height: 90,
                top: -55,
              }
        }
        titleTextStyles={{
          width: 380,

          fontSize: 18,
          marginTop: -6,
          textAlign: "center",
          transform: [{ translateX: -380 / 2 }, { translateY: -10 }],
        }}
        closeIcon={BtnSidebarClosePng}
      >
        <ScrollView
          style={{ maxHeight: 500 }}
          contentContainerStyle={{
            paddingHorizontal: isDesktop ? 80 : 20,
            paddingTop: 0,
            paddingBottom: 40,
            maxWidth: isDesktop ? 1000 : 350,
          }}
          showsVerticalScrollIndicator
          nestedScrollEnabled
        >
          <Image
            source={GameRulesLight}
            style={{ width: "100%", height: isDesktop ? 12 : 8 }}
            resizeMode="stretch"
          />

          <RenderHTML
            contentWidth={800}
            source={{ html }}
            tagsStyles={{
              h2: {
                fontSize: 24,
                color: "#fff",
                fontWeight: "bold",
                marginBottom: 12,
                textAlign: "center",
              },
              p: {
                fontSize: 16,
                color: "#fff",
                textAlign: "center",
              },
            }}
          />
        </ScrollView>
      </ModalReusable>
    </>
  );
}

export default GameRulesModal;

const styles = StyleSheet.create({
  form: {
    alignItems: "center",
  },
  label: {
    color: "white",
    fontSize: 18,
    alignSelf: "flex-start",
    marginBottom: 4,
    fontWeight: "500",
  },
  inputWrapper: {
    width: 300,
    height: 60,
    marginBottom: 20,
    justifyContent: "center",
    paddingHorizontal: 12,
  },
  input: {
    color: "white",
    fontSize: 20,
    padding: 0,
  },
  saveButton: {
    width: 210,
    height: 70,
    justifyContent: "center",
    alignItems: "center",
  },
  saveButtonText: {
    color: "white",
    fontSize: 22,
    fontWeight: "bold",
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
});
